import { genExpireIconColors } from '@halo/utils';
import { OnACallIcon } from '@halo/ui-chat-react';
import { Avatar, type AvatarProps } from '../../../../components/Avatar';
import { ExpireIcon } from '../../../../components/ExpireIcon';
import { expireTimeOptions } from '../../../../utils/expireTimeOptions';

interface ChatAvatarProps extends AvatarProps {
  src?: string;
  name?: string;
  onClick?: () => void;
  duration?: number;
  showExpireIcon?: boolean;
  isOnACall?: boolean;
}

export const ChatAvatar = memo(function ChatAvatar({
  src,
  name,
  duration,
  onClick,
  showExpireIcon = true,
  isOnACall = false,
  ...props
}: ChatAvatarProps) {
  const [expireColor, setExpireColor] = useState({
    expireBgColor: 'rgba(0, 0, 0, 0.5)',
    expireTextColor: 'rgb(255, 255, 255)',
  });

  const expireIcon = useMemo(() => {
    if (!showExpireIcon) {
      return null;
    }

    if (isOnACall) {
      return <OnACallIcon />;
    }

    // return duration && expireTimeOptions.findByValue(duration)?.avatarIcon;
    const [num, unit] = (duration && expireTimeOptions.findByValue(duration)?.text) || [];
    return <ExpireIcon num={num || ''} unit={unit || ''} />;
  }, [duration, showExpireIcon, isOnACall]);

  const onClick_ = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      e.stopPropagation();
      onClick?.();
    },
    [onClick]
  );

  useLayoutEffect(() => {
    if (src) {
      genExpireIconColors(src).then(
        ({ expireBgColor, expireTextColor }) => {
          setExpireColor({ expireBgColor, expireTextColor });
        },
        (error) => {
          console.error(error);
        }
      );
    }
  }, [src]);

  return (
    <Avatar
      src={src}
      name={name}
      size="sm"
      onClick={((e: React.MouseEvent<HTMLDivElement>) => onClick_(e)) as any}
      icon={expireIcon}
      floatFontSize="lg"
      iconFloatProps={{
        transform: 'translate(-25%, -50%)',
      }}
      css={{
        '--expire-bg-color': expireColor.expireBgColor,
        '--expire-text-color': expireColor.expireTextColor,
      }}
      {...props}
    />
  );
});
